export enum LayoutAttributes {
  fieldLabels = 1,
  quantities,
  groups,
  suppressRepeatingRows,
  wideLayout,
  totals,
  xAxisLabelsEnabled,
  yAxisLabelsEnabled
}

export interface AttributesPickerTranslation {
  attribute_field_labels: string;
  attribute_quantities: string;
  attribute_groups: string;
  attribute_wide_layout: string;
  attribute_totals: string;
  attribute_suppress_repeating_rows: string;
  attribute_xAxis_labels_enabled: string;
  attribute_yAxis_labels_enabled: string;
  show_label: string;
}
